export const USD_TO_EUR_RATE = 0.8534;

export function priceAmountToEur(amount, currency = 'EUR') {
  const value = Number(amount);
  if (!Number.isFinite(value)) return null;

  const code = String(currency || 'EUR').trim().toUpperCase();
  if (!code || code === 'EUR') return value;
  if (code === 'USD') return value * USD_TO_EUR_RATE;

  return null;
}

export function formatProductPriceEur(product, formatter, unavailableLabel) {
  const value = priceAmountToEur(product?.price_amount, product?.currency);
  if (value === null) return unavailableLabel;
  return formatter.format(value);
}

export function selectedProductsTotalEur(products = []) {
  const values = products
    .map((product) => priceAmountToEur(product?.price_amount, product?.currency))
    .filter((value) => value !== null);

  if (values.length === 0) return null;
  return values.reduce((sum, value) => sum + value, 0);
}
